import React from 'react';
import { NavLink } from 'react-router-dom';
import {withRouter} from "react-router";

import logo from "../../static/assets/GPRlogo.png"
import footerImg from "../../static/assets/sudoGPReight.jpg"

const Footer = () => {
  const dynamicLink = (route, linkText) => {
    return (
      <div className='nav-link-wrapper'>
        <NavLink to={route} activeClassName='nav-link-active'>
          {linkText}
        </NavLink>
      </div>
    )
  };

  return (
    <div className='footer-container'>
      <div className='footer-image' />
      <div className='footer-content-container'>
        <div className='image-container'>
          <img className='gpr-logo' src={logo}/>
        </div>
        <div className='links-container'>
          <a>{dynamicLink("/", "Home")}</a>
          <a>{dynamicLink("/about", "About")}</a>
          <a>{dynamicLink("/contact", "Contact")}</a>
        </div>
        <div className="copyright-container">
          <p>&copy; 2022 GPR &#124; all rights reserved</p>
        </div>
      </div>
    </div>
  )
}

export default withRouter(Footer);